export function getInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}
